export const generateArrayOfNumbersByLength = (length: number): Array<number> => {
  return Array.from({ length }, (_, index) => index + 1);
};
